<template src="./vehicleservicing.html"></template>
<script>
import Axios from "axios";
var moment = require("moment");

// Vehicle-specific servicing boxes (template_id always null). Mirrors
// the VehicleServiceHistory/Notes sibling pattern on vehicleprofile.vue.
export default {
  props: ["NewVehicle"],
  filters: {
    date: function (data) {
      var sendDate = "N/A";
      if (data != "" && data != null) {
        sendDate = moment(data).format("DD-MM-YYYY");
      }
      return sendDate;
    },
  },
  data() {
    return {
      Assignments: [],
      EditMode: false,
      MileageUnit: "miles",
      SubmitAssignment: this.blankForm(),
      EditingId: null,
    };
  },
  watch: {
    NewVehicle: {
      handler(val) {
        if (val && val.id) {
          this.GetAssignments();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    var CompanyData = JSON.parse(localStorage.getItem("Company"));
    if (CompanyData && CompanyData.mileage_unit == 2) {
      this.MileageUnit = "km";
    }
  },
  methods: {
    blankForm() {
      return {
        name: "",
        use_distance: false,
        interval_distance: null,
        warning_distance: null,
        use_date: false,
        interval_months: null,
        warning_days: null,
      };
    },
    GetAssignments() {
      Axios.post(Endpoints.ServiceAssignment.List, {
        token: localStorage.getItem("token"),
        vehicle_id: this.NewVehicle.id,
      }).then((Response) => {
        if (Response?.data?.success) {
          this.Assignments = Response.data.records;
        }
      });
    },
    StatusMeta(status) {
      switch (status) {
        case "overdue":
          return { cls: "btn-danger", icon: "fa-solid fa-triangle-exclamation", label: "Overdue" };
        case "due":
          return { cls: "btn-warning", icon: "fa-solid fa-triangle-exclamation", label: "Due" };
        case "approaching":
          return { cls: "btn-warning", icon: "fa-solid fa-triangle-exclamation", label: "Upcoming" };
        case "ok":
          return { cls: "btn-success", icon: "fa-solid fa-circle-check", label: "OK" };
        default:
          return { cls: "btn-light", icon: "fa-solid fa-clock", label: "Not yet due" };
      }
    },
    // Appends the actual due point to the status label whenever one has
    // been calculated. Pre-baseline assignments (status "not_configured" -
    // "Not yet due") genuinely have no due date/distance yet, since that
    // math only runs off a first recorded completion, so there is nothing
    // to append for those and the plain label is the accurate answer.
    StatusLabel(Assignment) {
      var meta = this.StatusMeta(Assignment.computed_status);
      var parts = [];
      if (Assignment.next_due_date) {
        parts.push(this.$options.filters.date(Assignment.next_due_date));
      }
      if (Assignment.next_due_distance) {
        parts.push(Assignment.next_due_distance + " " + (Assignment.distance_unit || this.MileageUnit));
      }
      if (parts.length === 0) {
        return meta.label;
      }
      return meta.label + " (" + parts.join(" / ") + ")";
    },
    OpenAddForm() {
      this.EditingId = null;
      this.SubmitAssignment = this.blankForm();
      this.$bvModal.show("ServiceAssignmentModal");
    },
    OpenEditForm(assignment) {
      this.EditingId = assignment.id;
      this.SubmitAssignment = {
        name: assignment.name,
        use_distance: !!assignment.use_distance,
        interval_distance: assignment.interval_distance,
        warning_distance: assignment.warning_distance,
        use_date: !!assignment.use_date,
        interval_months: assignment.interval_months,
        warning_days: assignment.warning_days,
      };
      this.$bvModal.show("ServiceAssignmentModal");
    },
    ResetForm() {
      this.SubmitAssignment = this.blankForm();
      this.EditingId = null;
    },
    OnModalOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.SaveAssignment();
    },
    ExtractErrors(data) {
      var errors = [];
      if (data && Array.isArray(data.errors)) {
        data.errors.forEach(function (e) {
          if (typeof e === "string") {
            errors.push(e);
          } else if (e && Array.isArray(e.errors)) {
            errors = errors.concat(e.errors);
          }
        });
      }
      return errors;
    },
    SaveAssignment() {
      var name = (this.SubmitAssignment.name || "").trim();
      var useDistance = !!this.SubmitAssignment.use_distance;
      var useDate = !!this.SubmitAssignment.use_date;

      if (name === "") {
        this.$swal.fire("Please enter a check name", "", "warning");
        return;
      }
      if (!useDistance && !useDate) {
        this.$swal.fire("Enable at least one of Distance or Date", "", "warning");
        return;
      }
      if (useDistance && (!this.SubmitAssignment.interval_distance || this.SubmitAssignment.interval_distance <= 0)) {
        this.$swal.fire("Please enter a valid distance interval", "", "warning");
        return;
      }
      if (useDate && (!this.SubmitAssignment.interval_months || this.SubmitAssignment.interval_months <= 0)) {
        this.$swal.fire("Please enter a valid interval in months", "", "warning");
        return;
      }

      var payload = {
        token: localStorage.getItem("token"),
        SubmitAssignment: {
          id: this.EditingId,
          vehicle_id: this.NewVehicle.id,
          name: name,
          use_distance: useDistance,
          interval_distance: useDistance ? this.SubmitAssignment.interval_distance : null,
          warning_distance: useDistance ? this.SubmitAssignment.warning_distance || 0 : null,
          use_date: useDate,
          interval_months: useDate ? this.SubmitAssignment.interval_months : null,
          warning_days: useDate ? this.SubmitAssignment.warning_days || 0 : null,
        },
      };

      var endpoint = this.EditingId
        ? Endpoints.ServiceAssignment.Update
        : Endpoints.ServiceAssignment.Create;

      Axios.post(endpoint, payload).then((Response) => {
        if (Response?.data?.success) {
          this.$bvModal.hide("ServiceAssignmentModal");
          this.GetAssignments();
        } else {
          var errors = this.ExtractErrors(Response?.data);
          var msg = errors.length ? errors.join("<br/>") : Response?.data?.message || "Something went wrong";
          this.$swal.fire({ title: "Unable to save", html: msg, icon: "error" });
        }
      });
    },
    RemoveAssignment(assignment) {
      var self = this;
      this.$swal({
        title: 'Remove "' + assignment.name + '"?',
        text: "This will stop tracking this servicing box for this vehicle. Its completion history is kept.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, remove it!",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          Axios.post(Endpoints.ServiceAssignment.Deactivate, {
            token: localStorage.getItem("token"),
            id: assignment.id,
          }).then((Response) => {
            if (Response?.data?.success) {
              self.GetAssignments();
            } else {
              self.$swal.fire("Error: " + (Response?.data?.message || "Something went wrong"), "", "error");
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.servicing-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.servicing-status-badge {
  width: 100%;
  text-align: left;
}
.servicing-empty {
  padding: 16px 0;
}
</style>
